export type RepoRef = {
  owner: string;
  repo: string;
};

export class GitHubUrlParser {
  static parseRepoUrl(urlValue: string): RepoRef | undefined {
    const url = this.parseUrl(urlValue);
    if (!url || url.hostname.toLowerCase() !== 'github.com') {
      return undefined;
    }

    const parts = this.getDecodedPathParts(url.pathname);
    if (parts.length < 2) {
      return undefined;
    }

    return {
      owner: parts[0],
      repo: this.stripDotGitSuffix(parts[1]),
    };
  }

  static parseCatalogLocationAnnotation(locationAnnotation: string): RepoRef | undefined {
    const prefix = 'url:';
    if (!locationAnnotation.toLowerCase().startsWith(prefix)) {
      return undefined;
    }

    return this.parseRepoUrl(locationAnnotation.slice(prefix.length));
  }

  private static parseUrl(urlValue: string): URL | undefined {
    try {
      const normalizedUrl = urlValue.replace(/^git@github\.com:/i, 'ssh://git@github.com/');
      return new URL(normalizedUrl);
    } catch {
      return undefined;
    }
  }

  private static getDecodedPathParts(pathname: string): string[] {
    return pathname
      .split('/')
      .filter(Boolean)
      .map(part => decodeURIComponent(part));
  }

  private static stripDotGitSuffix(repo: string): string {
    return repo.replace(/\.git$/i, '');
  }
}
